import React from 'react'

interface IRadioButtonQuestion {
    title: string
    name: string
    onChange: () => void
    isChecked: string
}

const RadioButtonQuestion = ({ title, name, onChange, isChecked }:IRadioButtonQuestion) => {
  return (
    <>
    <div className='__question-style'>
      <h4>{title}</h4>
      <div className='__form-question'>
        <div className="form-check">
            <input className="form-check-input" type="radio" name={name} id={`${name}_1`} onChange={onChange} value="Meget uenig" defaultChecked={isChecked === "Meget uenig" ? true : false } required={true} />
            <label className="form-check-label" htmlFor={`${name}_1`}>
              Meget uenig
            </label>
          </div>
          <div className="form-check">
            <input className="form-check-input" type="radio" name={name} id={`${name}_2`} onChange={onChange} value="Uenig" defaultChecked={isChecked === "Uenig" ? true : false } required={true} />
            <label className="form-check-label" htmlFor={`${name}_2`}>
              Uenig
            </label>
          </div>
          <div className="form-check">
            <input className="form-check-input" type="radio" name={name} id={`${name}_3`} onChange={onChange} value="Hverken enig eller uenig" defaultChecked={isChecked === "Hverken enig eller uenig" ? true : false } required={true} />
            <label className="form-check-label" htmlFor={`${name}_3`}>
              Hverken enig eller uenig
            </label>
          </div>
          <div className="form-check">
            <input className="form-check-input" type="radio"name={name} id={`${name}_4`} onChange={onChange} value="Enig" defaultChecked={isChecked === "Enig" ? true : false } required={true} />
            <label className="form-check-label" htmlFor={`${name}_4`}>
              Enig
            </label>
          </div>
          <div className="form-check">
            <input className="form-check-input" type="radio" name={name} id={`${name}_5`} onChange={onChange} value="Meget enig" defaultChecked={isChecked === "Meget enig" ? true : false } required={true} />
            <label className="form-check-label" htmlFor={`${name}_5`}>
              Meget enig
            </label>
          </div>
        </div>
      </div>
        
    </>
  )
}

export default RadioButtonQuestion